"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPeriods = void 0;
var PaymentPeriods;
(function (PaymentPeriods) {
    PaymentPeriods["ANNUAL"] = "annual";
    PaymentPeriods["MONTHLY"] = "monthly";
})(PaymentPeriods || (exports.PaymentPeriods = PaymentPeriods = {}));
//# sourceMappingURL=payment-periods.enum.js.map